<div class="dashboard dashboard-center" style="padding: 1rem; padding-top: 0px">
  <div class="d-flex align-items-center flex-nowrap">
    <div class="flex-grow-1">
      <app-pedidos-pendiente-filtro [dataObras]="" [selectObra]="obraSeleciona" (eventoFiltrar)="onFiltrar($event)"
        [selectCodigoObra]="codigobraSeleciona" [fechaMaxima]="fechaMaxima" [fechaMinima]="fechaMinima"
        [numberOrdersFiltered]="orders.length" (refreshData)="updateUrl()">
      </app-pedidos-pendiente-filtro>
    </div>
    <div class="flex-shrink-0">
      <a (click)="updateUrl()" class="btn btn-primary button-actualizar">
        <i class="bi bi-arrow-clockwise me-2"></i>
        Actualizar
      </a>
    </div>
  </div>

  <app-envios-pendientes-list></app-envios-pendientes-list>

  <div class="d-flex flex-wrap justify-content-around mt-3" *ngIf="orders.length > 0">
    <div *ngFor="let order of orders" class="container mt-md-4">
      <ng-container *ngIf="getPresentation(order) as view">
      <div class="box">
        <div class="header-card">
          <button *ngIf="order.flag_pending == '1'" class="pendiente-button"><span class="pendientes-icon"></span>Pendiente</button>
          <div class="label-title" style="flex-direction: column" *ngIf="view.showLoadingInfo">
            <label class="style-label" style="margin-bottom: 0px">Hora y boca carga:
            </label>
            <span class="style-span">{{ toAmOrPm(order.hourOne) || "No disponible" }} | {{ order.loadingMouth }}</span>
          </div>
        </div>
        <h2 class="title-principal">Despacho actual</h2>
        <div class="content">
          <div class="label-row">
            <label class="style-label">Fecha y hora entrega:
              <span class="style-span">{{ order.orderDate }}, {{ toAmOrPm(order.startTime) }}.</span></label>
          </div>
          <div class="label-row">
            <label class="style-label">{{view.destinationLabel}}: <span class="style-span">{{
                order.workName }}</span></label>
          </div>

          <div class="label-row">
            <label class="style-label">
              Dirección:
              <span class="style-span">{{ order.deliveryAddress }}</span>
            </label>
            <!--<button type="button" class="btn btn-primary "
            style="width: 30% !important;"
            (click)="abrirEnGoogleMaps(order.deliveryAddress)"
                     
                     >
              Google Maps
            </button>
             <button type="button" 
                     class="btn btn-primary "
                     style="width: 30% !important;"
                     (click)="abrirEnWaze(order.deliveryAddress)"
                     
                     >
              Waze
            </button>-->
          </div>

          <div class="label-row" *ngIf="view.showGuideInstruction && order.isOpen">
            <label class="style-label">Instrucción de guía:
              <span class="style-span"> {{ order.instructions }} </span></label>
          </div>
          <div class="label-row" *ngIf="view.showOperationalDetails">
            <label class="style-label">Observaciones(aditivos):
              <span class="style-span">{{ order.additiveRemarks }}</span></label>
          </div>

          <!--  -->
          <div class="label-row" *ngIf="view.showOperationalDetails">
            <label class="style-label">Camión:
              <span class="style-span">{{ order.currentTripNumber }}/{{ order.loadAmount }}</span></label>
          </div>
          <div class="label-row" *ngIf="view.showOperationalDetails">
            <label class="style-label">Camión anterior:
              <span class="style-span"> {{ order.truckNumber }} </span></label>
          </div>

          <div class="dashed-line"></div>
          <div class="label-row">
            <label class="style-label">Producto:
              <span class="style-span">{{ order.productDescription }}
              </span></label>
          </div>
          <div class="label-row">
            <label class="style-label">Cantidad a despachar:
              <span class="style-span">{{ order.actualQuantityShipped }} {{order.um}}
              </span></label>
          </div>
          <div class="label-row" *ngIf="view.showTotalAmount">
            <label class="style-label">Cantidad total pedido:
              <span class="style-span">{{ order.scheduledAmount }}
              </span></label>
          </div>
          <div class="label-row" *ngIf="view.showCone">
            <label class="style-label">Cono: <span class="style-span">{{ order.cone }} </span></label>
          </div>
          <div class="label-row" *ngIf=" order.rejectionFlag != ''">
            <label class="style-label">Observaciones rechazo:
              <span class="style-span red-label">{{ order.rejectionFlag }}
              </span></label>
          </div>
          <div class="dashed-line"></div>
          <div class="label-row" *ngIf="view.showSeal">
            <label class="style-label">{{view.sealLabel}}
              <span class="style-span">{{ order.sealNumber }} </span></label>
          </div>






          <div class="label-row">
            <label class="style-label">
              N° de guía:
              <span class="style-span">

                <!-- COMPONENTE HIJO OCULTO, PERO USADO COMO CONTROLADOR -->
                <app-pedidos-pendiente-visualizarguia #visorGuia [rutaPdf]="order.routePdfGuide" [tkt]="order.tkt.toString()" [hide]="true"
                  [isOnlyIcon]="false">
                </app-pedidos-pendiente-visualizarguia>

                <!-- SOLO EL NÚMERO ES CLICKEABLE -->
                <span class="clickable" (click)="visorGuia.onOpenModal()">
                  {{ order.folioNumberGD }}
                </span>

              </span>
            </label>
          </div>


          <div class="label-row">
            <label class="style-label">{{view.referenceLabel}}:
              <span class="style-span">{{ order.orderNumber }} </span></label>
          </div>


          <div class="footer-button ">
            <button type="button " class="btn btn-primary button-next" [disabled]="!isActive()"
              [routerLink]="['/PedidosPendientes/Detalle']" [queryParams]="{ tkt: order.tkt }">
              Continuar
            </button>
          </div>


        </div>
      </div>
      </ng-container>
    </div>
  </div>
</div>



